import React, {useState} from 'react';
import questionareStyle from './style';

export default function QuestionareContainer({slideTemplate}) {
	let style = questionareStyle();

	return (
		<div style={style.secondQuestionareContainer()}>
			<h1 style={style.landingTitle()}>MINDSET</h1>
			{slideTemplate()}
		</div>
	);
}
